import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, ViewChild} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ModeratRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {EmbedService} from "../../services/embed.service";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {DecimalPipe} from "@angular/common";
import {MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {SanierungIntroductionComponent} from "./sanierung-introduction.component";
import {MatDialog} from "@angular/material/dialog";
import {StepNavigationComponent} from "../../step/step.navigation.component";
import {PortalService} from "../../services/portal.service";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {WpcheckStartComponent} from "../wpcheck/wpcheck.start.component";
import {EnergyMapService} from '../../energy-map/services/energy.map.service';

/**
 *
 */
@Component({
  selector: 'app-moderat-sanierung',
  templateUrl: './sanierung.component.html',
  providers: [DecimalPipe]
})
export class SanierungComponent extends StepComponent implements AfterViewInit {

  /**
   * sidebar element that should be fixed while scrolling
   */
  @ViewChild('sidebar') sidebar: ElementRef;

  /**
   * The components container
   */
  @ViewChild('container') container: ElementRef;

  /**
   * The sidebar container
   */
  @ViewChild('sidebarContainer') sidebarContainer: ElementRef;

  /**
   * The side button to be visible and fixed at some point while scrolling
   */
  @ViewChild('sideButton') sideButton: ElementRef;

  /**
   * The next steps container
   */
  @ViewChild('nextStepsContainer') nextStepsContainer: ElementRef;

  /**
   * vertical offset for the sidebar while scrolling
   */
  sidebarOffset: number = 0;

  /**
   * vertical offset for the side button while scrolling
   */
  sideButtonOffset: number = 0;

  /**
   * Startpoint of the sidebar
   */
  sidebarInitialOffset: number = 0;

  /**
   * Startpoint of the side button
   */
  sideButtonInitialOffset: number = 0;

  /**
   * (input) data of the user
   */
  anfrage: ModeratAnfrage;

  /**
   * Formgroup for holding all selection elements for the measures
   */
  form: UntypedFormGroup;

  /**
   * Introduction dialog
   */
  introduction: MatDialogRef<SanierungIntroductionComponent> = null;

  /**
   * display the saving with this unit, can be switched by the user
   */
  savingUnit: string = 'kwh';

  /**
   * saving data for the measure, holding also the configuration for recommendations and showing hinttexts
   */
  measureData: {[key: string]: {saving: number, recommend: string, savingCo2?: number}};

  /**
   * list of possible measures for the user
   */
  measures: {[key: string]: string[]} = {
    insulation: ['dach', 'geschossdecke', 'fassade', 'kellerdecke', 'fenster', 'passivhaus'],
    heating: ['waermepumpe_luft', 'waermepumpe', 'waermepumpe_wasser', 'holzpellets', 'erdgas', 'fernwaerme', 'erneuern', 'nicht_erneuern'],
    additional: ['photovoltaik', 'solarthermie', 'lueftung', 'automation']
  };

  /**
   * List of recommendations measures.
   */
  recommendations: string[];

  /**
   * Holds the calculated costs form the backend.
   */
  costs: any;

  /**
   * Eventemitter if the costs changes
   */
  costsChanges: EventEmitter<any> = new EventEmitter<any>();

  /**
   * the one recommend heating measure.
   */
  recommendHeatingMeasure: string = null;

  /**
   * holds the calculated consumptions and the possible saving, based on the users selection
   */
  consumption = {
    kwh: {current: 0, sanitized: 0, percent: 0, recommend: 0},
    co2: {current: 0, sanitized: 0, percent: 0, recommend: 0}
  };

  /**
   * do we have consumption data or not
   */
  consumptionData: boolean = false;

  /**
   * The maximum saving of all measures to calculate the bar width
   */
  maxSaving: {kwh: number, co2: number} = {kwh: 0, co2: 0};

  /**
   * textkey for the recommand section in the sidebar.
   */
  recommendTextkey = 'moderat.sanierung.recommendation.text';

  /**
   * placeholder for the recommendation text
   */
  recommendPlaceholders: {co2_current: string, co2_percent: string, co2_sanitized: string};

  /**
   * toggles the recommand setion.
   */
  showRecommandSection: boolean = false;

  /**
   * toggle for the reset button
   */
  showResetButton: boolean = false;

  /**
   * toggle for the help text of the units.
   */
  showUnitHelp: boolean = false;

  /**
   * toggle for the first finanze expand panel
   */
  financeToggle: boolean = false;

  /**
   * Holds the api error to show the user some feedback.
   */
  apiErrors: string[] = [];

  /**
   * Holds warnings that are sent from the measure API
   */
  apiWarnings: string[] = [];

  /**
   * the users path
   */
  path: string;

  /**
   * name of a case that we need for some texts. i.e. in the introduction overlay
   */
  savingCase: string;

  /**
   * scrolloffset if embeded
   */
  scrollOffset: number = 0;

  /**
   * HOlds the entry URL of the advisor
   */
  entryUrl: string;

  /**
   * URL for the back link
   */
  previousLink: string = null;


  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean = false;

  /**
   * data for the dialog registration in the first section.
   */
  dialogData: any = {};

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * toggles for hinding element
   */
  hideElements: {rut: boolean, for: boolean} = {rut: false, for: false};

  /**
   * topics for the faq element
   */
  faqTopics: string[] = [];

  /**
   * The sum of all fundings
   */
  fundings: number;

  /**
   * toggle for the reset button at the end of the page.
   */
  showResetRequestButton: boolean = false;

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param embedService
   * @param decimalPipe
   * @param dialog
   * @param portalService
   * @param energyMapService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ModeratRequestService, protected elementService: ElementService,
              private embedService: EmbedService, private decimalPipe: DecimalPipe, public dialog: MatDialog, private portalService: PortalService,
              protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();
    this.form = new UntypedFormGroup({});
    this.path = this.anfrage.getPath();
    this.initDialogData();

    //check if it is internal portal
    this.internalPortal = this.portalService?.isInternalPortal();
    this.hideReportDownload = this.portalService?.getConfigAsBool('embed.newsletter.report.download');

    // some elements could be made hidden with the portal configuration
    for(let key of Object.keys(this.hideElements)) {
      this.hideElements[key] = parseInt(this.portalService.getConfig('moderat.hide.' + key)) === 1;
    }

    //show/dont show content in faq element
    if(this.hideElements.rut !== true) {
      this.faqTopics.push('planung', 'energieberatung');
    }
    if(this.hideElements.for !== true) {
      this.faqTopics.push('finanzierungsmittel');
    }
    if(this.internalPortal) {
      this.faqTopics.push('erfahrungsaustausch');
    }

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    // show the resetbutton
    this.showResetRequestButton = this.portalService.getConfigAsBool('moderat.enable.resetrequest');

    // in some cases we want to preset the measures, this is a small hack
    const presetMeasures = Object.keys(this.anfrage.massnahmen).length > 0 && this.anfrage.recalculateMeasures === false;
    this.anfrage.recalculateMeasures = false;

    // get measure calculation from the backend
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      if(presetMeasures === false && this.anfrage.getPath() === ModeratAnfrage.PATH_SPEZI) {
        // preset selected measures
        this.anfrage.massnahmen = {'heating': 'nicht_erneuern'};
        (this.anfrage.interesseMassnahmen?? '').split(",").forEach(massnahme => {
          switch(massnahme) {
            case 'heating':
              this.anfrage.massnahmen['heating'] = this.anfrage.verbrauchsanalyseInput.energietraeger_name.indexOf('waermepumpe') === 0? 'erneuern' : 'waermepumpe_luft';
              break;
            case 'dach':
              this.anfrage.massnahmen['geschossdecke'] = true;
            default:
              this.anfrage.massnahmen[massnahme] = true;
              break;
          }
        });
      }
      else if(presetMeasures === false){
        // reset the selected measures when initializing the component
        this.anfrage.massnahmen = {};
      }
      this.requestService.setAnfrage(this.anfrage);

      // calculate recommend meaures initially
      this.requestService.backendService.massnahmen(this.anfrage, requestId).subscribe(data => {
        this.anfrage.measureResult = data;
        this.requestService.setAnfrage(this.anfrage);
        this.updateFundings();

        // set current demand
        this.consumptionData = true;
        this.consumption.kwh.current = data.demand.kwh;
        this.consumption.co2.current = data.demand.co2;
        this.consumption.kwh.recommend = data.recommend.kwh;
        this.consumption.co2.recommend = data.recommend.co2;
        this.recommendations = data.recommend.measures;

        this.measureData = data.measures;
        this.costs = data.costs;
        this.costsChanges.emit(this.costs);
        this.initMeasureFormElements(this.measureData, presetMeasures);

        // calculate saving
        this.recalculateSaving(data.saving);

        // update the maximum saving
        this.updateMaxSaving();

        // calculate saving case
        this.setSavingCase();

        // warnings
        if(data.warnings && data.warnings.length > 0) {
          this.apiWarnings = data.warnings.map(warning => warning.code);
          this.showRecommandSection = true;
        }

        // check if we show the download module
        this.showDownload = !this.hideReportDownload && this.anfrage?.measureResult?.report && !this.internalPortal

        //Init side button offset
        setTimeout(() => this.initSidebuttonOffset(), 300);

        // show the introduction with a little delay to leave time for scrolling
        setTimeout(() => this.showIntroduction(), 800);
      }, error => this.onApiError(error));
    });

    // get the scrolloffset if we are embeded
    if(this.embedService.isEmbedded()) {
      this.subscriptions.push(this.embedService.scrollEvent.subscribe(data => this.scrollOffset = data.offset));
    }

    // set the entry Url of the advisor
    this.entryUrl = this.portalService.currentPortalId + '/moderat';

    if (this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.previousLink = '../../wpcheck/verbrauchsdaten';
    }
    else if (this.energyMapService.showEnergyMap(this.anfrage, 'moderat') === true
      && this.energyMapService.isEnergyMapDataDonated(this.anfrage) === false
      && this.energyMapService.getEnergyMapConfirmDonation(this.anfrage) !== 'n'
      && this.energyMapService.getEnergyMapBuildingNotIncludedInMap(this.anfrage) !== true
    ) {
      this.previousLink = '../../bestandsaufnahme/energy-map';
    }
    else {
      this.previousLink = '../../bestandsaufnahme/daemmung/3';
    }

    // show navigation element back to the wpcheck
    if(this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.stepService.setNavigationPreElement(
        new StepNavigationElement('moderat.nav.wpcheck.', true, WpcheckStartComponent.wpcheckUrl.replace('{{portalId}}', this.portalService.currentPortalId))
      );
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit() {
    super.ngAfterViewInit();

    // scroll to the top after init
    this.elementService.scrollToElement(document.querySelector('.' + StepNavigationComponent.STEPNAVIGATION_CLASS) || this.container.nativeElement);

    setTimeout(() => {
      this.initOnWindowResize();

      if(this.embedService.isEmbedded()) {
        this.subscriptions.push(
          this.embedService.scrollEvent.subscribe(data => this.updateSidebarPosition(data))
        );
        this.subscriptions.push(
          this.embedService.scrollEvent.subscribe(data => this.updateButtonPosition(data))
        )
      }
    }, 500);
  }

  /**
   * get the fundings sum from the request object.
   */
  updateFundings(): void {
    this.fundings = this.anfrage?.measureResult?.costs?.funding_grants?.sum;
  }

  /**
   * Basic error handling if the backend returns an invalid response.
   * @param result
   */
  onApiError(result: any) {
    if(result.error?.error && typeof result.error.error === "object" && result.error.error.map) {
      this.apiErrors = result.error.error.map(error => {return error.message});
    }
    else {
      this.apiErrors.push('moderat.sanierung.error.internal');
    }
  }

  /**
   * sets the savingcase for textoutput
   */
  setSavingCase(): void {
    if(this.anfrage.getPath() === ModeratAnfrage.PATH_EXPLO) {
      // explo path (show recommend measures)
      this.savingCase = 'none';
      if(this.consumption.kwh.percent < 0.75 && this.consumption.co2.percent < 0.75) {
        this.savingCase = 'high';
      }
      else if(this.consumption.kwh.percent > 0.75 && this.consumption.co2.percent < 0.75) {
        this.savingCase = 'high_co2';
      }
      else if(this.consumption.kwh.percent > 0.75 && this.consumption.co2.percent > 0.75 && (this.consumption.kwh.percent < 1 || this.consumption.co2.percent < 1)) {
        this.savingCase = 'medium';
      }
    }
    else {
      // spezi path (preselected measures, selected by the user)
      this.savingCase = 'none';
      if(this.consumption.co2.recommend < this.consumption.co2.sanitized && this.consumption.co2.percent < 1) {
        this.savingCase = 'recommend';
      }
      else if(this.consumption.co2.recommend > this.consumption.co2.sanitized && this.consumption.co2.percent < 1) {
        this.savingCase = 'user';
      }
    }
  }

  /**
   * shows/opens the introduction overlay for the page
   *
   * @param force
   */
  showIntroduction(force: boolean = false): void {
    const unit = 'kwh';

    // remember the last case onad only show the overlay if the case changes
    let lastCase = null;
    try {
      if (typeof sessionStorage != "undefined" && sessionStorage.getItem("mor-lastCase")) {
        lastCase = sessionStorage.getItem("mor-lastCase");
      }
    } catch (e) {

    }

    if(force === true || lastCase !== this.savingCase) {
      try {
        if (typeof sessionStorage != "undefined") {
          sessionStorage.setItem("mor-lastCase", this.savingCase);
        }
      } catch (e) {

      }

      // build the config for the overlay
      const introductionConfig = {
        position: {
          top: (100 + (Math.min(0, this.scrollOffset) * -1)) + 'px',
        },
        panelClass: 'sanierung-overlay',
        data: {
          path: this.anfrage.getPath(),
          case: this.savingCase,
          current: this.consumption.kwh.current,
          sanitized: this.consumption.kwh.sanitized,
          co2_current: this.consumption.co2.current,
          co2_sanitized: this.consumption.co2.sanitized,
          unit: unit
        }
      };

      // set focus on first interactive element in dialog (here the close button)
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;

      // open the dialog
      this.introduction = this.dialog.open(SanierungIntroductionComponent, introductionConfig);
    }
  }

  /**
   * UPdate the maximum saving, this is needed when the savingUnit changes
   */
  updateMaxSaving(): void {
    // find the bigges saving (= lowest number, because savings are always negative)
    this.maxSaving = {kwh: 0, co2: 0};
    Object.keys(this.measureData).forEach(measure => {
      this.maxSaving.kwh = Math.min(this.measureData[measure].saving, this.maxSaving.kwh);
      this.maxSaving.co2 = Math.min(this.measureData[measure].savingCo2, this.maxSaving.co2);
    });
  }

  /**
   * Updates the recommand text. This should be done with every measure selection change.
   */
  updateRecommendStatus(): void {
    this.recommendTextkey = 'moderat.sanierung.recommendation.text';
    this.showResetButton = false;

    if(this.consumption.co2.recommend < this.consumption.co2.sanitized) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.mehrco2';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    else if(this.consumption.co2.sanitized < this.consumption.co2.recommend) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.userwahl';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    else if(this.consumption.co2.sanitized > this.consumption.co2.current) {
      this.recommendTextkey = 'moderat.sanierung.recommendation.steigerung';
      this.showRecommandSection = true;
      this.showResetButton = true;
    }
    //build placeholders for recommend text
    this.recommendPlaceholders = {
      co2_current: this.decimalPipe.transform(this.consumption.co2.current * 1, '1.0-1'),
      co2_sanitized: this.decimalPipe.transform(this.consumption.co2.sanitized * 1, '1.0-1'),
      co2_percent: this.getCo2Percent(),
     }
  }

  /**
   * calculate the (possible) co2 reduction if co2.current !== 0  and set placeholder co2_percent
   */
  getCo2Percent(): string {
    if(this.consumption?.co2.current === 0 || this.consumption?.co2.current === this.consumption?.co2.sanitized){
      return this.decimalPipe.transform(Math.round(this.consumption.co2.sanitized * 100), '1.0-0');
    }
    const reduction = 1 - (this.consumption.co2.sanitized / this.consumption.co2.current);
    const reductionPossible = 1 - (this.consumption.co2.recommend / this.consumption.co2.current);
    return this.decimalPipe.transform((reduction - reductionPossible) * -100, '1.0-0');
  }

  /**
   * resets the recommand selection to the initial settings
   */
  resetRecommandMeasures(): void {
    this.measures.insulation.forEach(name => {
      if(this.measureData.hasOwnProperty(name)) {
        this.form.get(name).setValue(this.recommendations.indexOf(name) > -1, {onlySelf: true});
      }
    });

    // add heating measures
    this.recommendHeatingMeasure = this.measures.heating.find(element => this.recommendations.indexOf(element) > -1);
    this.form.get('heating').setValue(this.recommendHeatingMeasure, {onlySelf: true})

    // add additional measures
    this.measures.additional.forEach(name => {
      if(this.measureData.hasOwnProperty(name)) {
        this.form.get(name).setValue(this.recommendations.indexOf(name) > -1, {onlySelf: true});
      }
    });

    // update calculation with resettet selection
    this.onMeasureSelectionChange(this.form.getRawValue());
  }

  /**
   * Return the preset value for the form elements based on the path thet the user has choosen
   * @param measure
   * @param config
   */
  getValueForMeasure(measure, config): any {
    if(this.anfrage.getPath() === ModeratAnfrage.PATH_SPEZI) {
      const interesseMassnahmen = this.anfrage.interesseMassnahmen.split(",");
      if(measure === 'heating') {
        return interesseMassnahmen.indexOf('heating') > -1? (this.anfrage.verbrauchsanalyseInput.energietraeger_name.indexOf('waermepumpe') === 0? 'erneuern' : 'waermepumpe_luft') : 'nicht_erneuern';
      }
      if(measure === 'dach' || measure === 'geschossdecke') {
        return interesseMassnahmen.indexOf('dach') > -1;
      }
      return interesseMassnahmen.indexOf(measure) > -1;
    }
    return measure === 'heating'? config.recommend : config.recommend === 'empfehlung';
  }

  /**
   * initialize the form for the measures
   * @param data
   * @param useAnfrage
   */
  initMeasureFormElements(data: {[key: string]: {saving: number, recommend: string}}, useAnfrage: boolean): void {
    // add insulation measures
    this.measures.insulation.forEach(name => {
      if(data.hasOwnProperty(name)) {
        const config = data[name];
        this.form.addControl(name, new UntypedFormControl(useAnfrage? this.anfrage.massnahmen[name] : this.getValueForMeasure(name, config)))
      }
    });

    // add heating measures
    this.recommendHeatingMeasure = this.measures.heating.find(element => data[element]?.recommend === 'empfehlung');
    if(useAnfrage && this.anfrage.massnahmen['heating']) {
      // use heatiing from preset
      this.recommendHeatingMeasure = this.anfrage.massnahmen['heating'];
    }
    if(!this.recommendHeatingMeasure) {
      console.error("no recommand heating set", data);
    }
    this.form.addControl('heating', new UntypedFormControl(this.getValueForMeasure('heating', {recommend: this.recommendHeatingMeasure})))

    // add additional measures
    this.measures.additional.forEach(name => {
      if(data.hasOwnProperty(name)) {
        const config = data[name];
        this.form.addControl(name, new UntypedFormControl(useAnfrage? this.anfrage.massnahmen[name] : this.getValueForMeasure(name, config)))
      }
    });

    // subscribe to value changes of the form
    this.subscriptions.push(this.form.valueChanges.subscribe(changes => this.onMeasureSelectionChange(changes)));
  }

  /**
   * eventhandler if the user changes the selection of the measures
   * @param measures
   */
  onMeasureSelectionChange(measures: {[key: string]: any}): void {
    this.apiErrors = [];
    this.apiWarnings = [];
    this.anfrage.massnahmen = measures;

    // recalcualte the costs
    this.costs = null;
    this.consumptionData = false;
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate measures
      this.requestService.backendService.massnahmen(this.anfrage, requestId).subscribe(data => {
        this.anfrage.measureResult = data;

        this.consumptionData = true;
        this.measureData = data.measures;
        this.costs = data.costs;
        this.costsChanges.emit(this.costs);
        this.recalculateSaving(data.saving);

        // warnings
        if(data.warnings && data.warnings.length > 0) {
          this.apiWarnings = data.warnings.map(warning => warning.code);
          this.showRecommandSection = true;
        }
      }, error => {
        this.consumptionData = true;
        this.onApiError(error);
      });
    });

    // save selection in localstorage
    this.requestService.setAnfrage(this.anfrage);
  }

  /**
   * (re)calculate the consumption
   * @param data
   */
  recalculateSaving(data: any = null): void {
    // set the sanitized consumption to the current and reduce this with the single savings of each measure
    this.consumption.kwh.sanitized = data.kwh;
    this.consumption.co2.sanitized = data.co2;

    this.consumption.kwh.percent = this.consumption.kwh.sanitized / this.consumption.kwh.current;
    this.consumption.co2.percent = this.consumption.co2.sanitized / this.consumption.co2.current;

    // update the recommand text/status
    this.updateRecommendStatus();
  }

  /**
   * Textpostfix for some measures that is used in the hint texts
   * @param measure
   */
  getTextPostfix(measure: string): string {
    switch(measure) {
      case 'erneuern':
      case 'nicht_erneuern':
        return ['erdgas', 'heizoel', 'fluessiggas'].indexOf(this.anfrage.verbrauchsanalyseInput?.energietraeger_name) > -1? '.gasoel' : '';
    }
    return "";
  }

  /**
   * Returns the saving for a measure. This is based on the currently selected saving unit.
   * @param measure
   */
  getSaving(measure:string): number {
    if(this.savingUnit === 'co2') {
      return this.measureData[measure].savingCo2;
    }
    return this.measureData[measure].saving;
  }

  /**
   * togglethe savin unit between kwh and co2
   */
  toggleSavinUnit(): void {
    this.savingUnit = this.savingUnit === 'kwh'? 'co2' : 'kwh';
    this.updateMaxSaving();
  }

  /**
   * shows the financial details if the user clicks the details link.
   */
  showFinanceDetails(): void {
    this.financeToggle = true;

    this.elementService.scrollToElement(document.getElementById('costs'));
  }

  /**
   * Methods called on each window resize automatically
   */
  @HostListener('window:resize')
  initOnWindowResize(): void {
    this.initSidebarOffset();
    this.initSidebuttonOffset();
  }

  /**
   * initialize the offset of the sticky sidebar. This is called on each window resize automatically
   */
  initSidebarOffset(): void {
    if(this.sidebar?.nativeElement) {
      this.sidebarInitialOffset = ElementService.getTopOffset(this.sidebar.nativeElement, 0) - this.sidebarOffset;

      if (this.embedService.isEmbedded()) {
        this.embedService.triggerFakeScroll();

        const stickyHeader = this.portalService.getConfig('embed.stickyheader.mobile');
        if (stickyHeader) {
          this.sidebarInitialOffset -= parseFloat(stickyHeader);
        }
      }
    }
  }

  /**
   * initialize the offset of the scroll to top button. This is called on each window resize automatically
   */
  initSidebuttonOffset(): void {
    if(this.sideButton?.nativeElement) {
      this.sideButtonInitialOffset = ElementService.getTopOffset(this.sideButton.nativeElement, 0) - this.sideButtonOffset;

      if (this.embedService.isEmbedded()) {
        this.embedService.triggerFakeScroll();

        const stickyHeader = this.portalService.getConfig('embed.stickyheader.mobile');
        if (stickyHeader) {
          this.sideButtonInitialOffset -= parseFloat(stickyHeader);
        }
      }
    }
  }

  /**
   * Methods called on scrolling automatically
   *
   */
  @HostListener('window:scroll')
  updateOnWindowScroll(): void {
    this.updateSidebarPosition();
    this.updateButtonPosition();
  }

  /**
   * Update the vertical sidebar position. This is called on scrolling automatically
   * @param data
   */
  updateSidebarPosition(data: { position: number, offset: number } = null): void {
    // get current scroll Position
    const scrollPosition: number = data? data.offset * -1 : window.scrollY;

    // calculate maximum scrolling position
    const elementHeight: number = this.sidebar.nativeElement.offsetHeight;
    const containerHeight: number = this.sidebarContainer.nativeElement.offsetHeight;
    const maxScroll = containerHeight - elementHeight - 20;

    if(elementHeight > window.innerHeight) {
      // stop here, we have a very small window
      return;
    }

    // set the needed offset
    const oldSidebarOffset = this.sidebarOffset;
    this.sidebarOffset = Math.max(0, Math.min(maxScroll, scrollPosition - this.sidebarInitialOffset));

    //init sidebutton offset again when sidebar is not fixed anymore
    if (oldSidebarOffset === 0 && this.sidebarOffset > 0) {
      setTimeout(() => this.initSidebuttonOffset(), 0);
    }

  }

  /**
   * Update the vertical position of the scroll to top button. This is called on scrolling automatically
   * @param data
   */
  updateButtonPosition(data: { position: number, offset: number } = null): void {
    // get current scroll Position
    const scrollPosition: number = data? data.offset * -1 : window.scrollY;

    const buttonHeight: number = this.sideButton.nativeElement.offsetHeight;
    const nextStepsContainerHeight: number = this.nextStepsContainer.nativeElement.offsetHeight;
    const maxButtonScroll: number = nextStepsContainerHeight - buttonHeight;

    this.sideButtonOffset = Math.max(0, Math.min(maxButtonScroll, scrollPosition - this.sideButtonInitialOffset));
  }

  /**
   * some placeholders for error message
   */
  errorPlaceholder(): any {
    return {...this.anfrage.verbrauchsanalyseInput, ...this.anfrage.bestandsanalyseInput, ...{entryUrl: this.entryUrl}};
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'moc',
      }
    });
  }

  /**
   * Function is called if the users registered for the dialog
   * @param result
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }

  /**
   * Scroll to Top Button
   */
  scrollToTop() {
    this.embedService.scrollToTop();
    this.elementService.scrollToElement(this.container.nativeElement);
  }

  /**
   * Toggle value of financeToggle and init sidebutton offset when expanding or collapsing the panel
   */
  afterExpandCollapseFinancePanel(expand: boolean): void {
    this.financeToggle = expand;
    this.initSidebuttonOffset();
  }

  /**
   * Reset the request object in the browser and start a new session
   */
  resetRequest(): void {
    this.requestService.resetLocalStorage();
    this.requestService.backendService.resetRequestId();
  }

}
